<template>
  <!--  批量修改标签操作-->
  <el-dialog title="请选择要修改的标签"
             :visible.sync="modal.labelVisible"
             width="500px"
             custom-class="dialog-center">
    <el-form>
      <el-form-item v-for="(item,index) in plantLabelList"
                    :key="'p'+index"
                    :label="item.labelGroupName+'：'"
                    :label-width="formLabelWidth">
        <el-checkbox-group value-key="id"
                           v-model="item.checkPlantLabelList">
          <el-checkbox v-for="it in item.pmsProductLabels"
                       :key="it.id"
                       :label="it.id">{{it.name}}
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item v-for="(item,index) in merchLabelList"
                    :key="index"
                    :label="item.labelGroupName+'：'"
                    :label-width="formLabelWidth">
        <el-checkbox-group value-key="id"
                           v-model="item.checkMerchLabelList">
          <el-checkbox v-for="it in item.pmsProductLabels"
                       :key="it.id"
                       :label="it.id">{{it.name}}
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
    <div slot="footer"
         class="dialog-footer">
      <el-button @click="modal.labelVisible = false">取 消</el-button>
      <el-button type="primary"
                 @click="handleConfirm">确 认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { getLabelList } from '@/api/newProduct'

export default {
  name: "UpdateLabel",
  props: {
    modal: Object
  },
  data() {
    return {
      formLabelWidth: '100px',
      labelOptions: [
        {
          label: '热卖',
          value: 0
        },
        {
          label: '推荐',
          value: 1
        },
        {
          label: '新品',
          value: 0
        }],

      plantLabelList: [],
      merchLabelList: []
    }
  },
  created() {
    this.getLabelList()
  },
  methods: {
    getLabelList() {
      // 1平台标签 2商家标签
      getLabelList({ type: 1, mchtId: this.$store.getters.mchtId }).then(res => {
        for (var i of res.data) {
          i.checkPlantLabelList = []
        }
        this.plantLabelList = res.data
      })
      getLabelList({ type: 2, mchtId: this.$store.getters.mchtId }).then(res => {
        for (var i of res.data) {
          i.checkMerchLabelList = []
        }
        this.merchLabelList = res.data
      })
    },
    handleConfirm() {
      const AllLabelList = []
      for (var i of this.plantLabelList) {
        for (var j of i.checkPlantLabelList) {
          AllLabelList.push({
            labelId: j.id,
            labelName: j.name
          })
        }
      }
      for (var m of this.merchLabelList) {
        for (var mj of m.checkMerchLabelList) {
          AllLabelList.push({
            labelId: mj.id,
            labelName: mj.name
          })
        }
      }
      this.$emit('handleLabel', AllLabelList)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/pms/components/UpdateLabel.vue